import React from 'react'
import { Route, Routes, BrowserRouter } from 'react-router-dom'
import { toast, ToastContainer } from 'react-toastify'
import FooterComponent from '../components/global/footer'
import NavbarComponent from '../components/global/navbar'
import DisplayToast from '../components/global/Snackbar'
import URL from '../constants/urls'
import useNetwork from '../hooks/NetworkDetector'
import About from '../pages/about/About'
import Contact from '../pages/contact'
import DownloadTicket from '../pages/download-ticket'
import Home from '../pages/home'
import Payment from '../pages/payment/Payment'
import PaymentFails from '../pages/payment/PaymentFails'
import RecoverTicket from '../pages/recover-ticket/RecoverTicket'
import 'react-toastify/dist/ReactToastify.css'

function RoutesComponent() {
	const isOnline =  useNetwork()

	const notify = (type, message) => {
        if (type === 'error') {
            toast.error(message, {
                position: toast.POSITION.TOP_RIGHT
            })
        } else if (type === 'success') {
            toast.success(message, {
                position: toast.POSITION.TOP_RIGHT
            })
        }
    }
	
	return (<div>
		<BrowserRouter forceRefresh className="mt-3">
			<NavbarComponent />

			{!isOnline ?
				<DisplayToast 
				text='Please check the Internet Connection!'
				type='error'
				title='Warning'
			/> : null}
			<Routes>
				<Route
					path={URL.HOME}
					element={
						<Home notify={notify} />
					}
				/>
				<Route
					path={URL.ABOUT}
					element={
						<About />
					}
				/>
				<Route
					path={URL.CONTACT}
					element={
						<Contact />
					}
				/>
				<Route
					path={URL.PAYMENT}
					element={
						<Payment  notify={notify} />
					}
				/>

				<Route
					path={URL.PAYMENT_SUCCESS}
					element={
						<DownloadTicket notify={notify}  />
					}
				/>

				<Route
					path={URL.PAYMENT_FAIL}
					element={
						<PaymentFails />
					}
				/>

				<Route
					path={URL.RECOVER_TICKET}
					element={
						<RecoverTicket />
					}
				/>
			</Routes>
			<FooterComponent />
			<ToastContainer limit={1} />

		</BrowserRouter>

		</div>
	)
}
export default RoutesComponent
